import * as React from 'react';

import { StatsigProvider } from '@coursera-web/statsig';

import EnterpriseHeaderFooterWrapper from 'bundles/unified-common/pageUtils/EnterpriseHeaderFooterWrapper';
import EnterprisePageGuard from 'bundles/unified-common/pageUtils/EnterprisePageGuard';
import EnterpriseUserStateCheckWrapper from 'bundles/unified-common/pageUtils/EnterpriseUserStateCheckWrapper';

type Props = {
  children: React.ReactNode;
  hideFooterTopBanner?: boolean;
  /**
   * Providers rendered immediately inside EnterprisePageGuard, so their queries never fire
   * on a request the guard redirects away. (LRNRSCCSS-6315)
   */
  postGuardProvider?: React.ComponentType<React.PropsWithChildren<{}>>;
};

/**
 * @description Provides the base functionality required for all enterprise pages.
 * Enables the enterprise header/footer with critical modal manager, basic program checks and critical user state checks.
 * With this backed by the EnterprisePageDataProvider, you can safely assume an enterprise page wrapped by this has sufficient
 * functionality for enterprise learners.
 */
const EnterprisePageTemplateWrapper = ({ children, hideFooterTopBanner, postGuardProvider }: Props) => {
  const PostGuardProvider = postGuardProvider ?? React.Fragment;

  return (
    <StatsigProvider>
      <EnterprisePageGuard>
        <PostGuardProvider>
          <EnterpriseHeaderFooterWrapper hideFooterTopBanner={hideFooterTopBanner}>
            <EnterpriseUserStateCheckWrapper>{children}</EnterpriseUserStateCheckWrapper>
          </EnterpriseHeaderFooterWrapper>
        </PostGuardProvider>
      </EnterprisePageGuard>
    </StatsigProvider>
  );
};

export default EnterprisePageTemplateWrapper;
